/* eslint-disable import/prefer-default-export */
export enum MapLayerType {
  DEFAULT = 'default',
  SATELLITE = 'satellite'
}
